module.exports = __webpack_public_path__ + "img/zu 387.7c66a6c9.png";